import { render, staticRenderFns } from "./OrderCounters.vue?vue&type=template&id=5bb88fd0&"
import script from "./OrderCounters.vue?vue&type=script&lang=js&"
export * from "./OrderCounters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports